import type { getUniqueProcedureCodesQuery } from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { getUniqueProcedureCodesQueryDoc } from "../../remote/queries/getUniqueProcedureCodes.gql";
import { AlaffiaClientModule } from "./modules";

type ProcedureCodesModuleArgs = AlaffiaClientModuleArgs;

export class ProcedureCodesModule extends AlaffiaClientModule {
  constructor(args: ProcedureCodesModuleArgs) {
    super(args);
  }

  getUniqueProcedureCodes = async (input: {
    includes: string;
  }): ClientReturnType<
    getUniqueProcedureCodesQuery["uniqueProcedureCodes"]
  > => {
    const result = await this.runGqlQuery(
      getUniqueProcedureCodesQueryDoc,
      { includes: input.includes },
      "getUniqueProcedureCodes",
    );

    return {
      data: result.data?.uniqueProcedureCodes ?? null,
      error: result.error ?? null,
    };
  };
}
